import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ConnectServerService } from '../../services/connect-server.service';
import { map, Observable, Subject } from 'rxjs';
import { User } from '../../interfaces/user';
import { Connect } from '../../classes/connect';
import { Menu } from '../../interfaces/menu';
import { ApiResponse } from '../../interfaces/api-response';
import { UrlService } from '../../services/url.service';
import { Store } from '@ngrx/store';
import { UserState } from '../../ngrx/user/user.reducer';
import * as UserActions from '../../ngrx/user/user.actions';
import { selectUserInfo } from '../../ngrx/user/user.selectors';

declare var bootstrap: any;

@Component({
    selector: 'app-navbar',
    imports: [CommonModule],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.scss'
})

export class NavbarComponent implements OnInit {

  user$!: Observable<User | null>;

  // public menu!: Menu[];
  menuNavbar$!: Observable<Menu[]>;
  menuUserNavbar$!: Observable<Menu[]>;
  routeParam: string | null = null;

  currentPage: string = "";
  email: string = '';
  menuOpen = false;
  private openGroup: string | null = null;

  constructor(public authService: AuthService, private router: Router,
    private connectServerService: ConnectServerService,
    private urlService: UrlService,
    private store: Store<{ user: UserState }>,
    private elementRef: ElementRef<HTMLElement>) {
    this.currentPage = this.getRootUrl();

    // si ottiene i risultati
    this.store.dispatch(UserActions.loadUserPermissions());

    // this.nickname$ = store.select(state => state.user.userInfo).pipe(
    //   map((user) => user ? user?.nickname : 'Profile')
    // );

    if (this.authService.isLoggedIn()) {
      // this.authService.getUser();
      // si richiama al server
      this.store.dispatch(UserActions.loadUserInfo());
    }
  }

  ngOnInit(): void {
    // this.user$ = this.authService.getInfoUserLogged();
    // si chiede le info
    this.user$ = this.store.select(selectUserInfo);
    this.menuNavbar$ = this.store.select(state => state.user.permissions).pipe(
      map((val) => val ? val.menu : []),
      map((menus: Menu[]) => menus.filter(menu => menu.level === 0))
    );
    this.menuUserNavbar$ = this.store.select(state => state.user.permissions).pipe(
      map((val) => val ? val.menu_user : []),
      map((menus: Menu[]) => menus.filter(menu => menu.level === 0))
    );
    // this.getMenu();
    // this.authService.getInfoMenu().subscribe(
    //   (val) => {
    //     this.getMenu();
    //   });
    this.urlService.getInfoCurrenPage().subscribe(
      (val: string) => {
        //console.log("QUI")
        this.currentPage = val;
      }
    )

  }

  private getRootUrl(): string {
    if (typeof window !== "undefined") {
      const currentUrl: string = window.location.pathname;
      const urlSegments: string[] = currentUrl.split('/');
      return urlSegments[1]; // Il secondo elemento è la radice dell'URL
    } else {
      return "null";
    }
  }

  lastSubmenuVoice(order: number, submenu: Menu[]) {
    if(order < submenu.length) {
      return true;
    }
    else return false;
  }

  navigate(src: string) {
    this.router.navigate([src]);
    this.currentPage = src;
    this.openGroup = null;
    this.closeMobileMenu();
  }

  toggleGroup(name: string): void {
    this.openGroup = this.openGroup === name ? null : name;
  }

  isGroupOpen(name: string): boolean {
    return this.openGroup === name;
  }

  isCurrentPath(path: string): boolean {
    const normalized = path.replace(/^\//, '').split('/')[0];
    return this.currentPage === normalized || this.currentPage === path;
  }

  getMenuStyles(page: string): any {
    const isActive = this.isCurrentPage(page);
    return {
      'border-bottom': isActive ? '4px solid white' : 'none',
    };
  }

  getLinkStyles(page: string): any {
    const isActive = this.isCurrentPage(page);
    return {
      'border-bottom': isActive ? '4px solid white' : 'none',
      'padding-bottom': isActive ? '7px' : '0',
    };
  }

  isCurrentPage(src: string): boolean {
    //console.log("current: ", this.currentPage);
    const srcLowerCase = src.toLowerCase().replace(/\s+/g, '');
    if (this.currentPage == "" && srcLowerCase == "home") {
      return true;
    }
    if ((this.currentPage == "archivioStorico" || this.currentPage == "archivioArtistico") && srcLowerCase == "archivio") {
      return true
    }
    if ((this.currentPage == "inventarioStorico" || this.currentPage == "inventarioArtistico") && srcLowerCase == "inventario") {
      return true
    }
    if ((this.currentPage == "nuovaSchedaStorica" || this.currentPage == "nuovaSchedaArtistica") && srcLowerCase == "nuovascheda") {
      return true
    }
    else return (this.currentPage == srcLowerCase);
  }

  logout() {
    this.closeMobileMenu();
    this.authService.logoutUser();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const menu = document.getElementById('navbarNav');
    const isOpen = this.menuOpen || !!menu?.classList.contains('show');
    if (!isOpen) {
      return;
    }

    const target = event.target as Node | null;
    if (target && this.elementRef.nativeElement.contains(target)) {
      return;
    }

    this.closeMobileMenu();
  }

  private closeMobileMenu(): void {
    this.menuOpen = false;
    this.openGroup = null;
    const menu = document.getElementById('navbarNav');
    if (!menu?.classList.contains('show')) {
      return;
    }
    bootstrap.Collapse.getOrCreateInstance(menu, { toggle: false }).hide();
  }

  goToSettings() {
    this.router.navigate(["settings"]);
  }

}
